<template>
    <div id="button-container">
        <button type="button" @click="$emit('back')" class="FPBtn btn btn-light" title="First Page" :disabled="disableBack"><i class="mdi mdi-chevron-left font-18"></i>Back</button>
        <button class="button " type="button" id="deny" @click="$emit('deny', $event)" :disabled="disableDeny">DENY</button>
        <button class="button" type="button" id="accept" @click="$emit('accept', $event)" :disabled="disableAccept">ACCEPT</button>
        <button class="button" type="button" id="override" @click="$emit('override',$event)" :disabled="disableOverride">OVERRIDE</button>
        <button type="button" @click="$emit('next')" class="FPBtn btn btn-light" title="First Page" :disabled="disableNext" :style="nextStyle">Next<i class="mdi mdi-chevron-right font-18"></i></button>
    </div>
</template>

<script>
export default {
    props: ['disableBack', 'disableDeny', 'disableAccept', 'disableOverride', 'disableNext', 'nextStyle'],
}
</script>

<style lang="scss" scoped>
#button-container {
  text-align: center;
  padding-bottom:1em;
  > :first-child
  {
    margin-right: 10px;
    margin-left: 0;
  }
}

.button {
  margin-top: 10px;
  margin-right: 10px;
  color: #222;
  padding: 10px;
  width: 150px;
  height: 42px;
  border-radius: 10px;
  border: none;
  background-color: #BFD9F1;
}

.button:disabled
{
  background-color: darkgray !important;
}

#accept {
  background-color: #0acf97;
  color: white;
  margin-right: 0;
}

#deny {
  background-color: #fa5c7c;
  color: white;
}

#override {
  background-color: #ffbc00;
  color: white;
  margin-left: 10px;
}

.FPBtn
{
  border-radius: 10px;
  height: 42px;
  line-height: normal;
}
</style>